module.exports = __webpack_public_path__ + "static/media/ECPAT.43e94172.png";